import { Feature } from 'config/features';

import { FeatureMap } from './types';

export const buildFeatureMap = (featureList: Feature[]): FeatureMap =>
    Object.fromEntries(featureList.map((name) => [name, true]));
